import { Skeleton } from '@shared/components/ui/shadcn/skeleton';

export const LoadingState = () => {
  return (
    <div className="px-6 pt-4">
      <div className="flex items-center justify-between mb-4">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-10 w-32" />
      </div>
      <div className="space-y-2">
        {Array.from({ length: 10 }).map((_, index) => (
          <Skeleton key={index} className="h-12 w-full" />
        ))}
      </div>
    </div>
  );
};
